import moment from "moment";
import { DEFAULT_PROPERTIES_RADIUS } from "dash-common";

const getValidUnitFilter = (unitValue: number) => {
  if (unitValue === 5) {
    return { min: unitValue };
  }

  return { min: unitValue, max: unitValue };
};

export type PropertiesFilter = {
  unitNumberOfUnits?: number;
  unitNumberOfBedrooms: {
    min?: number;
    max?: number;
  };
  unitNumberOfBathrooms: {
    min?: number;
    max?: number;
  };
  buildingTypes?: string[];
  amenities?: string[];
  marketAreaIds?: string[];
  completionDate?: number;
  yearBuildRange: {
    min?: number;
    max?: number;
  };
  projectStatuses?: string[];
  locationFilter?: {
    lat?: number;
    lng?: number;
    radiusToSearchInMiles: number;
  };
  priceRange: {
    min?: number;
    max?: number;
  };
  constructionDateRange?: {
    startDate?: any;
    endDate?: any;
  };
  createdAt?: string;
  searchText?: string | null;
};

export const formatPropertiesFilter = (filters: Record<string, any>) => {
  const {
    units,
    prices,
    radius,
    location,
    amenityIds,
    buildingTypes,
    yearBuildRange,
    projectStatuses,
    constructionDateRange,
    createdAt,
    marketAreaIds,
    completionDate,
    transactionType,
  } = filters;

  return {
    unitNumberOfUnits: units?.unitNumberOfUnits,
    unitNumberOfBedrooms: getValidUnitFilter(units?.unitNumberOfBedrooms),
    unitNumberOfBathrooms: getValidUnitFilter(units?.unitNumberOfBathrooms),
    buildingTypes,
    amenityIds,
    marketAreaIds,
    completionDate,
    yearBuildRange:
      yearBuildRange?.min && yearBuildRange?.max ? yearBuildRange : undefined,
    projectStatuses,
    transactionType,
    locationFilter: location
      ? {
          lat: location?.lat,
          lng: location?.lng,
          radiusToSearchInMiles: radius || DEFAULT_PROPERTIES_RADIUS,
        }
      : undefined,
    priceRange: prices?.min || prices?.max ? prices : undefined,
    constructionDateRange:
      constructionDateRange?.startDate && constructionDateRange?.endDate
        ? constructionDateRange
        : undefined,
    createdAt: createdAt && moment(createdAt).toISOString(),
  };
};

export const formatPropertiesListLocationFilter = (
  filters: Record<string, any>
) =>
  filters.location && {
    locationFilter: {
      lat: filters.location?.lat,
      lng: filters.location?.lng,
      radiusToSearchInMiles: filters.radius || DEFAULT_PROPERTIES_RADIUS,
    },
  };
